// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
export enum SecurityProjectScanStatus {
  'NOT_YET_SCANNED' = 'Not yet scanned.',
  'NO_REPOSITORY_FOUND' = 'No repository found.',
  'SCAN_FAILED' = 'Scan failed.',
  'SCAN_PARTIALLY_COMPLETED' = 'Scan partially completed.',
  'SCAN_SUCCESSFULLY_COMPLETED' = 'Scan successfully completed.',
}
